/**
 * Holds a reference to react-router's `navigate` function so that non-React
 * modules (e.g. socket handlers in wss.js) can perform in-app navigation
 * without falling back to window.location.replace – which triggers the
 * browser's "changes you made may not be saved" prompt.
 *
 * Usage:
 *   - Call `setNavigate(navigate)` once from a mounted React component.
 *   - Call `getNavigate()` from anywhere to retrieve the function.
 */

let _navigate = null;

export const setNavigate = (nav) => {
  _navigate = nav;
};

export const getNavigate = () => _navigate;
